import { useState } from "react";
import { Link } from "react-router-dom";
import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { articles } from "@/mocks/articles";
import { categoryList } from "@/mocks/categories";

export default function Home() {
  const [faqOpen, setFaqOpen] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setFaqOpen(faqOpen === index ? null : index);
  };

  const faqs = [
    { q: "蘑菇视频APP是否免费？", a: "是的，蘑菇视频APP完全免费下载和使用。基础功能全部免费开放，普通用户即可享受高清流畅的观看体验。我们也提供VIP会员服务，可解锁4K超清、离线下载等高级特权。" },
    { q: "支持哪些设备平台？", a: "蘑菇视频全面支持安卓手机、苹果iPhone、iPad平板等主流设备。安卓系统要求Android 8.0以上，iOS系统要求iOS 14.0以上。" },
    { q: "视频播放会卡顿吗？", a: "蘑菇视频采用自研智能播放引擎，支持P2P加速和智能码率自适应技术。在网络环境良好的情况下，最高支持4K超清流畅播放。即使在弱网环境下，也能自动调整为合适画质，减少卡顿。" },
    { q: "如何下载视频到本地？", a: "VIP会员用户可以在视频播放页面点击下载按钮，选择清晰度后即可将视频保存到本地。支持同时下载多个视频，下载完成后可在「我的下载」中离线观看。" },
    { q: "蘑菇视频安全吗？", a: "蘑菇视频非常重视用户安全与隐私。APP通过多重安全检测，不含任何恶意代码。用户数据采用AES-256加密传输，观看记录仅保存在本地设备。我们绝不会收集用户的个人隐私信息。" },
  ];

  const siteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "蘑菇视频",
    url: "https://www.moguvideo.com",
    description: "蘑菇视频提供91视频、91在线视频等视频平台官方APP下载，支持安卓、苹果、iPad版，播放器软件免费安装，高清流畅不卡顿。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.moguvideo.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "蘑菇视频",
    url: "https://www.moguvideo.com",
    description: "专业视频播放器APP开发商，提供91视频、91在线视频等平台官方APP下载服务。",
    contactPoint: {
      "@type": "ContactPoint",
      email: "support@moguvideo.com",
      contactType: "customer service",
      availableLanguage: ["Chinese"],
    },
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  };

  return (
    <>
      <SEOHead
        title="蘑菇视频-91视频与91在线视频APP下载安卓苹果iPad版 | 播放器软件免费安装高清流畅"
        description="蘑菇视频提供91视频、91在线视频等视频平台官方APP下载，支持安卓、苹果、iPad版，播放器软件免费安装，高清流畅不卡顿。蘑菇视频，您的掌上高清影院。"
        keywords="蘑菇视频,91视频,91在线视频,APP下载,安卓版,苹果版,iPad版,播放器,软件,免费安装"
        canonicalUrl="https://www.moguvideo.com"
        ogImage="https://readdy.ai/api/search-image?query=Mushroom%20video%20player%20app%20brand%20banner%20with%20warm%20coral%20orange%20gradient%2C%20modern%20minimalist%20design%2C%20cinematic%20film%20elements%2C%20smartphone%20mockup%2C%20clean%20composition&width=1200&height=630&seq=og-home&orientation=landscape"
        schemaData={{ ...siteSchema, ...orgSchema, ...faqSchema }}
      />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20coral%20orange%20and%20cream%20tones%2C%20cinematic%20bokeh%20lights%2C%20floating%20geometric%20film%20reel%20elements%2C%20modern%20minimalist%20design%2C%20soft%20dreamy%20atmosphere%2C%20clean%20composition%20with%20subtle%20tech%20vibe&width=1600&height=900&seq=hero-home&orientation=landscape"
            alt="蘑菇视频播放器背景"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

          <div className="relative z-10 w-full px-4 md:px-6 py-20">
            <div className="max-w-[1280px] mx-auto text-center">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
                <i className="ri-sparkling-2-line text-accent-500 text-sm"></i>
                <span className="text-xs text-background-50 font-medium">2026最新版本 · 全新界面体验</span>
              </div>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
                蘑菇视频
                <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-3 text-background-50/90">
                  高清流畅 · 即刻畅享
                </span>
              </h1>

              <p className="text-sm md:text-base text-background-50/80 max-w-[640px] mx-auto mb-10 leading-relaxed">
                蘑菇视频 — 专业视频播放器APP，支持91视频、91在线视频等多平台。安卓、苹果、iPad全端覆盖，免费安装，高清流畅不卡顿，为您带来极致的掌上观影体验。
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
                <a
                  href="#download"
                  className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 shadow-lg shadow-primary-500/25"
                >
                  <i className="ri-download-2-line text-lg"></i>
                  立即免费下载
                </a>
                <Link
                  to="/category/hot"
                  className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-sm font-medium border border-background-50/30 hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-film-line text-lg"></i>
                  浏览视频资源
                </Link>
              </div>

              <div className="flex items-center justify-center gap-6 text-background-50/70 text-xs">
                <div className="flex items-center gap-1.5">
                  <i className="ri-android-line text-base"></i>
                  <span>安卓版</span>
                </div>
                <span className="w-px h-4 bg-background-50/30"></span>
                <div className="flex items-center gap-1.5">
                  <i className="ri-apple-line text-base"></i>
                  <span>苹果版</span>
                </div>
                <span className="w-px h-4 bg-background-50/30"></span>
                <div className="flex items-center gap-1.5">
                  <i className="ri-tablet-line text-base"></i>
                  <span>iPad版</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="w-full bg-background-50 py-10 md:py-14">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              {[
                { value: "5000万+", label: "累计用户", icon: "ri-user-star-line" },
                { value: "99.9%", label: "播放流畅度", icon: "ri-speed-up-line" },
                { value: "10万+", label: "视频资源", icon: "ri-video-line" },
                { value: "4.9分", label: "用户评分", icon: "ri-star-line" },
              ].map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                    <i className={`${stat.icon} text-accent-500 text-xl`}></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-bold text-foreground-950 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="w-full bg-background-100 py-16 md:py-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                为什么选择蘑菇视频？
              </h2>
              <p className="text-sm text-foreground-600 max-w-[560px] mx-auto">
                六大核心优势，为您带来前所未有的移动观影体验
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {[
                { icon: "ri-4k-line", title: "4K超清画质", desc: "支持最高4K分辨率播放，HDR增强让画面色彩更加真实饱满，暗部细节清晰可见，享受影院级视觉盛宴。" },
                { icon: "ri-speed-up-line", title: "流畅不卡顿", desc: "自研智能播放引擎，P2P加速技术确保高清视频秒加载。弱网环境下智能降码率，始终保持流畅播放体验。" },
                { icon: "ri-smartphone-line", title: "全平台覆盖", desc: "完美支持安卓手机、苹果iPhone、iPad等设备。大屏小屏随心切换，随时随地想看就看。" },
                { icon: "ri-download-2-line", title: "离线下载", desc: "VIP会员支持高清视频离线下载，最多可同时下载50部。通勤路上、飞机上畅享无网络观影。" },
                { icon: "ri-shield-check-line", title: "安全可靠", desc: "通过多重安全检测认证，不含恶意代码。用户数据加密传输，观看记录仅保存在本地，隐私无忧。" },
                { icon: "ri-cast-line", title: "一键投屏", desc: "支持DLNA、AirPlay、Miracast三大协议，轻松投屏到电视。大屏观影更过瘾，音画完全同步。" },
              ].map((feature, i) => (
                <div key={i} className="bg-background-50 rounded-xl p-6 hover:bg-background-50 transition-colors">
                  <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                    <i className={`${feature.icon} text-primary-500 text-xl`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">{feature.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="w-full bg-background-50 py-16 md:py-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
                  海量视频分类
                </h2>
                <p className="text-sm text-foreground-600">电影、电视剧、综艺、动漫... 总有你想看的</p>
              </div>
              <Link
                to="/category/hot"
                className="flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部分类
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {categoryList.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className="bg-background-100 rounded-xl p-5 text-center hover:bg-primary-50 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 group-hover:bg-accent-200 transition-colors flex items-center justify-center">
                    <i className={`${cat.icon} text-accent-500 text-xl`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 whitespace-nowrap">{cat.name}</h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{cat.description}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Download Section */}
        <section id="download" className="w-full bg-background-100 py-16 md:py-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                下载蘑菇视频APP
              </h2>
              <p className="text-sm text-foreground-600 max-w-[480px] mx-auto">
                选择你的设备平台，免费下载安装，即刻开启高清观影之旅
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[960px] mx-auto">
              {[
                { icon: "ri-android-line", title: "安卓版下载", desc: "支持Android 8.0及以上", size: "约80MB", version: "v6.2.0" },
                { icon: "ri-apple-line", title: "苹果iOS版下载", desc: "支持iOS 14.0及以上", size: "约95MB", version: "v6.2.0", highlight: true },
                { icon: "ri-tablet-line", title: "iPad版下载", desc: "支持iPadOS 14.0及以上", size: "约95MB", version: "v6.2.0" },
              ].map((dl, i) => (
                <div
                  key={i}
                  className={`rounded-2xl p-7 text-center transition-all ${
                    dl.highlight
                      ? "bg-primary-500 text-background-50 shadow-lg shadow-primary-500/20"
                      : "bg-background-50"
                  }`}
                >
                  <div className={`w-14 h-14 mx-auto mb-4 rounded-2xl flex items-center justify-center ${
                    dl.highlight ? "bg-background-50/20" : "bg-primary-100"
                  }`}>
                    <i className={`${dl.icon} text-2xl ${dl.highlight ? "text-background-50" : "text-primary-500"}`}></i>
                  </div>
                  <h3 className={`text-lg font-semibold mb-2 ${dl.highlight ? "text-background-50" : "text-foreground-950"}`} style={{ fontFamily: "var(--font-heading)" }}>
                    {dl.title}
                  </h3>
                  <p className={`text-sm mb-1 ${dl.highlight ? "text-background-50/80" : "text-foreground-600"}`}>
                    {dl.desc}
                  </p>
                  <p className={`text-xs mb-4 ${dl.highlight ? "text-background-50/60" : "text-foreground-500"}`}>
                    {dl.size} · {dl.version}
                  </p>
                  <button
                    className={`w-full py-3 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                      dl.highlight
                        ? "bg-background-50 text-primary-500 hover:bg-background-100"
                        : "bg-primary-500 text-background-50 hover:bg-primary-600"
                    }`}
                  >
                    立即下载
                  </button>
                </div>
              ))}
            </div>

            <p className="text-center mt-6 text-xs text-foreground-500">
              扫描二维码或在浏览器中打开官网，即可下载安装。如遇安装问题，请查看
              <Link to="/articles" className="text-primary-500 hover:text-primary-600 cursor-pointer ml-1">安装教程</Link>
            </p>
          </div>
        </section>

        {/* Articles Section */}
        <section className="w-full bg-background-50 py-16 md:py-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
                  最新资讯
                </h2>
                <p className="text-sm text-foreground-600">使用教程、产品动态、行业资讯一网打尽</p>
              </div>
              <Link
                to="/articles"
                className="flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部文章
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {articles.slice(0, 3).map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/50 transition-colors cursor-pointer group"
                >
                  <div className="aspect-video overflow-hidden">
                    <img
                      src={article.cover}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-2.5">
                      <span className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-500">{article.date}</span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full bg-background-100 py-16 md:py-20">
          <div className="max-w-[800px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                常见问题
              </h2>
              <p className="text-sm text-foreground-600">关于蘑菇视频的常见疑问，这里都有答案</p>
            </div>

            <div className="flex flex-col gap-3">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-background-50 rounded-xl overflow-hidden"
                >
                  <button
                    className="w-full px-6 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-background-100 transition-colors"
                    onClick={() => toggleFaq(index)}
                  >
                    <span className="text-sm font-medium text-foreground-950 pr-4">{faq.q}</span>
                    <i
                      className={`text-foreground-400 text-base transition-transform duration-200 flex-shrink-0 ${
                        faqOpen === index ? "ri-subtract-line rotate-180" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  {faqOpen === index && (
                    <div className="px-6 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="w-full bg-background-50 py-16 md:py-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="relative rounded-2xl overflow-hidden p-10 md:p-14 text-center">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20coral%20orange%20and%20cream%20flowing%20waves%2C%20cinematic%20soft%20glow%2C%20minimalist%20modern%20design%2C%20elegant%20atmosphere%2C%20clean%20composition%20with%20light%20texture&width=1200&height=400&seq=cta-home&orientation=landscape"
                alt=""
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-accent-500/80"></div>
              <div className="relative z-10">
                <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  即刻下载，畅享高清世界
                </h2>
                <p className="text-sm text-background-50/90 mb-8 max-w-[480px] mx-auto">
                  蘑菇视频 — 5000万用户的选择。免费下载，高清流畅，随时随地想看就看。
                </p>
                <a
                  href="#download"
                  className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-primary-500 text-sm font-semibold hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-download-cloud-2-line text-lg"></i>
                  免费下载蘑菇视频
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}